import * as styles from '../../ServicesLayout.css';
import * as React from 'react';
import { IServicesLayoutProps } from '../../types';
import { useMediaQuery } from '../../../../../../../../hooks';

export const ServicesLayoutDesktop = ({ services, competitors, error }: IServicesLayoutProps) => {
  const narrowScreen = useMediaQuery('(min-width: 1024px) and (max-width: 1200px)');

  return (
    <div className={styles.container}>
      <div className={styles.services}>
        {services}
        {!narrowScreen && competitors}
      </div>
      {error && <div className={styles['error']}>{error}</div>}
      {narrowScreen && <div className={styles.competitors}>{competitors}</div>}
    </div>
  );
};
